const metaAuth = {
	auth: [1]
}

export default [
	{
		path: '/',
		name: 'index',
		redirect: '/home',
	},
	{
		path: '/home',
		name: 'home',
		meta: metaAuth,
		/* meta: {
			auth: metaAuth,
		}, */
		component: () => import('@/views/Home/index.vue'),
		children: [
			// 个人中心
			{
				name: 'personalCenter',
				path: '/personalCenter',
				meta: metaAuth,
				component: () => import('@/views/PersonalCenter/index.vue')
			},
			// 绑定手机号
			{
				name: 'boundPhone',
				path: '/boundPhone',
				meta: metaAuth,
				component: () => import('@/views/CellPhone/boundPhone.vue')
			},
			// 验证手机号
			{
				name: 'verifyPhone',
				path: '/verifyPhone',
				meta: metaAuth,
				component: () => import('@/views/CellPhone/verifyPhone.vue')
			},
			// 实名认证
			{
				name: 'certification',
				path: '/certification',
				meta: metaAuth,
				component: () => import('@/views/Certification/index.vue')
			},
			// 联系客服
			{
				name: 'service',
				path: '/service',
				meta: metaAuth,
				component: () => import('@/views/Certification/service.vue')
			},
			// 账号登录
			{
				path: '/login',
				name: 'login',
				// meta: metaAuth,
				component: () => import('@/views/Login/index.vue'),
			},
			// 免密登录
			{
				path: '/sshLogin',
				name: 'sshLogin',
				// meta: metaAuth,
				component: () => import('@/views/Login/sshLogin.vue'),
			},
			// 协议
			{
				path: '/agreement',
				name: 'agreement',
				// meta: metaAuth,
				component: () => import('@/views/Login/component/agreement.vue'),
			},
			// 996账号注册
			{
				path: '/register',
				name: 'register',
				// meta: metaAuth,
				component: () => import('@/views/Login/register.vue'),
			},
			// 忘记密码
			{
				path: '/forgetPsd',
				name: 'forgetPsd',
				// meta: metaAuth,
				component: () => import('@/views/Login/forgetPsd.vue'),
			},
			// 验证手机号
			{
				path: '/loginVerifyPhone',
				name: 'loginVerifyPhone',
				// meta: metaAuth,
				component: () => import('@/views/Login/verifyPhone.vue'),
			},
			// 设置新密码
			{
				path: '/newPsd',
				name: 'newPsd',
				// meta: metaAuth,
				component: () => import('@/views/Amend/newPsd.vue'),
			},
			// 修改密码
			{
				path: '/changePsd',
				name: 'changePsd',
				meta: metaAuth,
				component: () => import('@/views/Amend/changePsd.vue'),
			},
			// 确认订单
			{
				path: '/pay',
				name: 'pay',
				meta: metaAuth,
				component: () => import('@/views/Pay/index.vue'),
			},
			// 领取礼包
			{
				path: '/Gift',
				name: 'Gift',
				meta: metaAuth,
				component: () => import('@/views/Gift/index.vue'),
			},
			// 联系客服
			{
				path: '/contact',
				name: 'contact',
				meta: metaAuth,
				component: () => import('@/views/contact/index.vue'),
			},
		]
	},
	// {
	// 	path: '/login',
	// 	name: 'login',
	// 	component: () => import(/* webpackChunkName: "login" */ '@/views/Login/index.vue'),
	// },
	{
		path: '/logout',
		name: 'logout',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '@/views/Logout.vue'),
	},
]
